module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "background": "#ffffff"
    },
    attrs: {
      "id": "topPanel"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h6', [_vm._v("Groups")]), _vm._v(" "), (_vm.menu_view.showCreateGroup) ? _c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("Create new Group")]), _vm._v(" "), _c('div', {
    staticClass: "form-card"
  }, [_c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" Group Name  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.group.group_name),
      expression: "group.group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.group.group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.group.group_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h4', [_vm._v("Select Group Type")]), _vm._v(" "), _c('div', [_c('h5', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.group.group_type),
      expression: "group.group_type"
    }],
    attrs: {
      "type": "radio",
      "value": "55"
    },
    domProps: {
      "checked": _vm._q(_vm.group.group_type, "55")
    },
    on: {
      "__c": function($event) {
        _vm.group.group_type = "55"
      }
    }
  }), _vm._v("  "), _c('b', [_vm._v("Business to Business Group")])]), _vm._v(" "), _c('p', [_vm._v("Add Only Businesses here")])]), _vm._v(" "), _c('div', [_c('h5', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.group.group_type),
      expression: "group.group_type"
    }],
    attrs: {
      "type": "radio",
      "value": "56"
    },
    domProps: {
      "checked": _vm._q(_vm.group.group_type, "56")
    },
    on: {
      "__c": function($event) {
        _vm.group.group_type = "56"
      }
    }
  }), _vm._v("  "), _c('b', [_vm._v("Business to Customer Group")])]), _vm._v(" "), _c('p', [_vm._v("Add Only Customers here...")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" Group Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.group.group_description),
      expression: "group.group_description"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.group.group_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.group.group_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.createGroup
    }
  }, [_vm._v("Create")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "card-link btn sp-button-02 sp-button-02-lt",
    staticStyle: {
      "float": "right",
      "font-size": "13px",
      "margin-top": "0.1em",
      "text-transform": "inherit",
      "background-color": "#21a6f3",
      "color": "#ffffff",
      "border-radius": "5px",
      "padding": "3px 10px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('')
      }
    }
  }, [_vm._v("\r\n                Cancel\r\n              ")])])])]) : _c('div', [_vm._l((_vm.groups), function(group, index) {
    return _c('div', {
      staticClass: "card card-row",
      staticStyle: {
        "border-radius": "0px",
        "margin-bottom": "0.6em"
      }
    }, [_c('div', [_c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/account/group/' + group.group_ref
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "80%"
      }
    }, [_c('p', [_c('b', [_vm._v(_vm._s(group.group_name))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(Object.keys(group.group_members).length) + " Members")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "20%"
      }
    }, [_c('a', {
      staticClass: "card-link btn sp-button-02 sp-button-02-lt",
      staticStyle: {
        "float": "right",
        "font-size": "13px",
        "margin-top": "0.1em",
        "text-transform": "inherit",
        "background-color": "#21a6f3",
        "color": "#ffffff",
        "border-radius": "5px",
        "padding": "3px 10px"
      },
      attrs: {
        "href": '/account/group/' + group.group_ref
      }
    }, [_vm._v("\r\n                    Open\r\n                  ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "card-link btn sp-button-02 sp-button-02-lt",
    staticStyle: {
      "font-size": "13px",
      "margin-top": "0.1em",
      "text-transform": "inherit",
      "background-color": "#21a6f3",
      "color": "#ffffff",
      "border-radius": "5px",
      "padding": "3px 10px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('showCreateGroup')
      }
    }
  }, [_vm._v("\r\n            Create Group\r\n          ")])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-faea1e4e"}!./src/pages/Account/Groups/template.html
// module id = 593
// module chunks = 0